import http from 'shared/utils/http';

export const fetchMappedEdi = (companyId) => {
  return http.get('/edi/mapping', { companyId });
};
